<template lang="pug">
  div(class="separable")
    div(class="container")
      pesquisa(
        @search="pesquisarSimples",
        :hasPesquisaAvancada="true"
        @searchAdvanced="pesquisarAvancado"
        :placeHolder="placeholderPesquisaSimples"
      )
        template(slot="pesquisaAvancada")
          form(@submit.prevent="$emit('search', searchObject.simpleFieldValue)")
            .panel.positionInput
              el-row(:gutter="20")
                el-col(:span="12")
                  p.titulo Processo:
                  el-input(
                    v-model="searchObject.advancedObject.numeroProcesso",
                    maxlength="25"
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                el-col(:span="12")
                  p.titulo CPF/CNPJ do interessado:
                  el-input(
                    v-model="searchObject.advancedObject.cpfCnpj",
                    class="input-with-select",
                    v-mask="['###.###.###-##', '##.###.###/####-##']",
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
              el-row.margin-top(:gutter="20")
                el-col(:span="12")
                  p.titulo Nome/Razão social do interessado:
                  el-input(
                    v-model="searchObject.advancedObject.nomeRazaoSocial",
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                el-col(:span="12")
                  p.titulo Tipo de processo:
                  el-select.full-width(
                    v-model='searchObject.advancedObject.tipo',
                    placeholder='Selecione',
                    clearable,
                    @input="$emit('advancedInput', searchObject.advancedObject)"
                  )
                    el-option(
                      v-for='tipo in tipoProcessosFiltrados',
                      :key='tipo.codigo',
                      :label='tipo.nome',
                      :value='tipo.codigo',
                      class="label-option"
                    )
    app-listagem(
      :tituloCard="tituloCard"
      :hasActionButton="true"
      :sizeActionButton="sizeActionButton"
      :nameActionButton="nameActionButton"
      :hasHeaderAndRefreshButton="true"
      :headerLabel="headerLabel"
      :dataForTable="processosFisicos"
      :totalElements="totalProcessos"
      :pagina="pagina"
      @changePage="changePage"
      @updateListagem="updateListagem"
      @click="criarProcessoFisico"
    )
      template(slot="columns")
        el-table-column(
          prop='numeroProcesso',
          width="auto"
          label='Processo',
        )
        el-table-column(
          label='CPF/CNPJ do interessado',
          width="auto"
          prop="cpfCnpj"
        )
        el-table-column(
          label='Nome/Razão social do interessado',
          prop="nomeRazaoSocial",
          min-width='155',
          sortable
        )
        el-table-column(
          label='Tipo de processo',
          prop="tipo",
          min-width="100"
          sortable
        )
        el-table-column(
          label='Ações',
          width="105"
        )
          template(slot-scope='scope')
            el-dropdown(trigger="click", size="small")
              el-button(type='primary', size="mini")
                | Ações &nbsp
                i.fal.fa-chevron-down
              el-dropdown-menu(slot='dropdown' v-if="isPa")
                el-dropdown-item(v-if="scope.row.isFinalizado")
                  .flex(@click="visualizarProcesso(scope.row)")
                    i.far.fa-cogs
                    | &nbsp Gerenciar processo
                el-dropdown-item(v-else)
                  .flex(@click="visualizarProcesso(scope.row)")
                    i.far.fa-file
                    | &nbsp Continuar cadastro
              el-dropdown-menu(slot='dropdown' v-else)
                el-dropdown-item
                  .flex(@click="visualizarProcesso(scope.row.numeroProcesso)")
                    i.fal.fa-cogs
                    | &nbsp Gerenciar processo

</template>

<script>
import { mapActions, mapState } from 'vuex'
import AppListagem from '@/components/shared/AppListagem'
import Pesquisa from '@/components/Pesquisa'

const advancedObject = {
  nomeRazaoSocial: null,
  tipo: null,
  cpfCnpj: null,
  numeroProcesso: null
}

export default {
  components: {
    AppListagem,
    Pesquisa
  },

  data () {
    return {
      isPa: process.env.ESTADO === 'pa',
      processosFisicos: [],
      totalProcessos: null,
      pagina: 0,
      searchObject: {
        simpleFieldValue: '',
        advancedObject: _.cloneDeep(advancedObject),   // eslint-disable-line
        simpleSearch: true,
        pagina: 0
      },
      headerLabel: 'Listagem de processos físicos',
      tituloCard: 'Processo físico',
      sizeActionButton: 'medium',
      nameActionButton: 'Cadastrar',
      placeholderPesquisaSimples: 'Informe o Nome/Razão social do interessado ou tipo de processo'
    }
  },

  created () {
    this.pesquisarSimples()
    this.getTiposProcessos()
  },

  computed: {
    ...mapState({
      tiposProcessos: state => state.processos.tiposProcessos
    }),

    tipoProcessosFiltrados () {
      const tiposProcessosExcluidos = ['GENERICO']
      let tiposProcessosFiltrados = this.tiposProcessos.filter(tipoProcesso => !tiposProcessosExcluidos.includes(tipoProcesso.codigo))
      return tiposProcessosFiltrados
    }
  },

  methods: {
    ...mapActions({
      getProcessos: 'cadastroProcessoFisico/findProcessosByFilter',
      getTiposProcessos: 'processos/getTiposProcessos'
    }),

    criarProcessoFisico () {
      this.$router.push({
        name: 'cof/cadastroProcessoFisico'
      })
    },

    limpar () {
      this.searchObject.simpleFieldValue = ''
      this.searchObject.advancedObject = _.cloneDeep(advancedObject)  // eslint-disable-line
      this.searchObject.pagina = 0
      this.$emit('clear')
      this.pesquisarSimples()
    },

    updateListagem () {
      this.searchObject.simpleFieldValue = ''
      this.changePage(1)
    },

    async pesquisarSimples (valueSimpleSearch) {
      let filtroSimples = this.setFiltroSimpleSearch(valueSimpleSearch)

      await this.getProcessos(filtroSimples).then(data => {
        this.processosFisicos = data.content
        this.totalProcessos = data.totalElements
      })

      this.searchObject.pagina = 0

      this.$store.commit('processos/SET_FILTRO_PROCESSOS', this.searchObject)
      this.$emit('advancedSearch', this.searchObject.advancedObject)
    },

    setFiltroSimpleSearch (valueSimpleSearch) {
      let filtro = {
        simplificado: true,
        parametro: valueSimpleSearch,
        ordemDirecao: 'ASC',
        pagina: this.searchObject.pagina
      }

      return filtro
    },

    async pesquisarAvancado () {
      let filtroAvancado = this.setFiltroAdvancedSearch()

      await this.getProcessos(filtroAvancado).then(data => {
        this.processosFisicos = data.content
        this.totalProcessos = data.totalElements
      })

      this.searchObject.pagina = 0

      this.$store.commit('processos/SET_FILTRO_PROCESSOS', this.searchObject)
      this.$emit('advancedSearch', this.searchObject.advancedObject)
    },

    setFiltroAdvancedSearch () {
      let filtro = {
        simplificado: false,
        nomeRazaoSocialInteressado: this.searchObject.advancedObject.nomeRazaoSocial,
        cpfCnpj: this.searchObject.advancedObject.cpfCnpj,
        numeroProcesso: this.searchObject.advancedObject.numeroProcesso,
        tipo: this.searchObject.advancedObject.tipo,
        ordemDirecao: 'ASC',
        pagina: this.searchObject.pagina
      }

      return filtro
    },

    visualizarProcesso (processo) {
      let numeroProcesso = processo.numeroProcesso
      if (this.isPa) {
        if (processo.isFinalizado) {
          this.$router.push({
            name: 'cof/visualizarProcessoFisico',
            params: {
              numeroProcesso
            }
          })
        } else {
          this.$router.push({
            name: 'cof/cadastroProcessoFisico',
            params: {
              numeroProcesso
            }
          })
        }
      } else {
        this.$router.push({
          name: 'cof/visualizarProcessoFisico',
          params: {
            numeroProcesso
          }
        })
      }
    },

    changePage (newPage) {
      this.searchObject.pagina = newPage - 1
      this.pesquisarSimples()
    }
  }
}
</script>
<style lang="scss" scoped>
.panel {

  .margin-top{
    margin-top: 10px;
  }

  .titulo{
    font-size: 14px;
  }

}

.full-width {
  width: 100%;
}

.positionInput {
  margin-top: 15px;
}

.card-container {
  border-radius: 10px;
  margin: 1%;
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/processoFisico/ListagemProcessoFisico.vue